<template lang="pug">
.v-search-result.search-result.main-page-section
	v-loader(:loading="loading")
	.container(v-if="data")
		.search-result__head(v-if="data.title || data.message")
			.search-result__head-wrap(v-if="data.title")
				component.search-result__head-title( :is="data.titleLevel ? data.titleLevel : 'h1'" :class="data.titleStyleLevel") {{data.title}}
			.search-result__head-message(v-if="data.message && !data.empty")
				.tag-message {{data.message}}
		.search-result__content
			h3.search-result__empty(v-if="data.empty" ) {{ data.empty }}
			template(v-else)
				.search-result__left(v-if="data.menu && data.menu.length")
					.search-menu
						template(v-for="(item, index) in data.menu" :key="index" )
							.search-menu__list
								component.search-menu__item(:is="item.href ? 'a' : 'div'") {{item.title}}
								.search-menu__submenu(v-if="item.items && item.items.length")
									template(v-for="(submenu, subIndex) in item.items" :key="subIndex" )
										a.search-menu__subitem(:href="submenu.href") {{submenu.title}}
				.search-result__right
					.search-result__grid
						.search-result__item(v-for="(item, index) in data.items" :key="item.id || index")
							v-product( :product="item" )
					.search-result__pagination(v-if="state.page")
						v-page-nav(:page="state.page" :pagination-button="data.paginationButton" @navigate="navigate")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],
	data() {
		return {
			data: null,
			state: {
				page: null
			},
		}
	},
	methods: {
		dataSet(data, options = {}) {
			this.data = data;
			this.state.page = this.data.page;
		},
		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},
		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					page: this.state.page
				}
			}, dataSetOptions);
		},
	}
}
</script>